import styled from 'styled-components';
import crossIconSVG from 'icons/cross.svg';
import downloadIconSVG from 'icons/download.svg';
import imgIconSVG from 'icons/img.svg';
import { helpTextDanger, borderDangerBase } from 'styles/variables';
import { Stack } from 'components/Stack';
import { ReactSVG } from 'react-svg';

export const Box = styled.div<{ loading: boolean; error: boolean }>`
  position: relative;
  width: 100%;
  padding: 11px;
  color: ${({ theme, error }) => (error ? helpTextDanger : 'inherit')};
  border: 1px solid
    ${({ theme, loading, error }) => {
      if (error) return borderDangerBase;
      if (loading) return theme.configs.CTAButton.bgColor;
      return 'rgba(0, 0, 0, 0.38)';
    }};
  border-radius: 4px;

  & > * + * {
    margin-top: 5px;
  }
`;

export const Content = styled(Stack).attrs({
  align: 'center',
  gap: 8,
})`
  overflow: hidden;
`;

export const FileNameContainer = styled.span`
  font-size: 16px;
  line-height: 19px;
  flex: 1;
  display: flex;
  overflow: hidden;
`;

export const FileName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileExt = styled.span`
  flex-shrink: 0;
`;

export const ProgressWrapper = styled.div`
  position: absolute;
  bottom: 3px;
  display: flex;
  justify-content: center;
  width: calc(100% - 22px);
`;

export const FileIcon = styled(ReactSVG).attrs((props) => {
  return { src: imgIconSVG, ...props };
})`
  width: 18px;
  height: 18px;
`;

export const RemoveIcon = styled(ReactSVG).attrs((props) => {
  return { src: crossIconSVG, ...props };
})`
  width: 14px;
  height: 14px;
  opacity: 0.8;
  cursor: pointer;
`;

export const DownloadIcon = styled(ReactSVG).attrs((props) => {
  return {
    src: downloadIconSVG,
    ...props,
  };
})`
  width: 24px;
  height: 24px;
  opacity: 0.8;
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.configs.CTAButton.bgColor};
  }
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 3px;

  // Workaround: This div is auto-generated by react-svg, we need to override so the height is correct
  > div > div {
    display: flex;
  }
`;
